import { LoginRutas, GetHeaderRequest, GetResponseBody } from './RutasConfig';

export const Cambiar_Contrasena_Request = async (pToken, NombreUsuario, ContrasenaActual, ContrasenaNueva) => {
    const data = { NombreUsuario, ContrasenaActual, ContrasenaNueva };
    const result = await fetch(LoginRutas.Cambiar_Contrasena, {
        method: 'POST',
        headers: GetHeaderRequest(pToken),
        body: JSON.stringify(data)
    });
    return await GetResponseBody(result);
};
export const Cambiar_Pin_Request = async (pToken, NombreUsuario, ContrasenaActual, ContrasenaNueva) => {
    const data = { NombreUsuario, ContrasenaActual, ContrasenaNueva };
    const result = await fetch(LoginRutas.Cambiar_Pin, {
        method: 'POST',
        headers: GetHeaderRequest(pToken),
        body: JSON.stringify(data)
    });
    return await GetResponseBody(result);
};
export const Login_Request = async (pUsuario, pContrasena, pEmp_Id, pSuc_Id) => {
    const data = { Usuario: pUsuario, Contrasena: pContrasena, Emp_Id: pEmp_Id, Suc_Id: pSuc_Id };
    const result = await fetch(LoginRutas.Login, {
        method: 'POST',
        body: JSON.stringify(data),
        headers: {
            'Content-Type': 'application/json'
        }
    });
    return await GetResponseBody(result);
};

export const Login_Token_Request = async (pToken, pEmp_Id, pSuc_Id) => {
    const data = { Token: pToken, Emp_Id: pEmp_Id, Suc_Id: pSuc_Id };
    const result = await fetch(LoginRutas.Login_Token, {
        method: 'POST',
        body: JSON.stringify(data),
        headers: {
            'Content-Type': 'application/json'
        }
    });
    return await GetResponseBody(result);
};